import React, { useContext } from "react";
import { Button, Typography } from "@mui/material";
import { CustomModalContext } from "../../../contexts/CustomModalContext";

type CancelModalButtonProps = {
    customsx?: object;
};

export default function CancelModalButton({
    customsx,
}: CancelModalButtonProps) {
    const { updateIsCustomModalActive } = useContext(CustomModalContext);

    return (
        <Button
            sx={{
                display: "flex",
                height: "3rem",
                padding: "0rem 1.5rem",
                justifyContent: "center",
                alignItems: "center",
                gap: "0.625rem",
                alignSelf: "stretch",
                borderRadius: "1rem",
                background: "#E5EEF5",
                margin: "auto",
                ...customsx,
                "&:hover": {
                    backgroundColor: "#fff",
                    color: "#005499",
                    border: "1px solid #005499",
                    "& .MuiTypography-root": {
                        color: "#005499", // Nouvelle couleur de la typographie
                    },
                    "& .MuiSvgIcon-root": {
                        color: "#005499", // Nouvelle couleur de l'icône
                    },
                },
            }}
            onClick={() => updateIsCustomModalActive(false)}
        >
            <Typography
                sx={{
                    color: "#005499",
                    /* Mobile/Body/Medium/Texte 1 */
                    fontFamily: "Roboto",
                    fontSize: "1rem",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "normal",
                }}
            >
                Annuler
            </Typography>
        </Button>
    );
}
